export default __webpack_public_path__ + "static/media/hotel2.196abbf1.jpg";